<ion-content
  class="cookie-modal"
  scrollEvents="false"
  fullscreen="false"
  >
  <div class="modal-content" [ngClass]="{'french': currentLang === 'fr'}">
    <button class="close-btn" (click)="dismissModal()">✕</button>

    <h6>{{ translations[currentLang].modalTitle }}</h6>
    <p>{{ translations[currentLang].modalDescription }}</p>

    <!-- ESSENTIAL -->
    <div class="consent-section">
      <div class="category-box" (click)="toggleDetails('essential')">
        <ion-item lines="full" class="toggle-row">
          <ion-label>
            <h3>{{ translations[currentLang].essential }}</h3>
          </ion-label>
          <ion-toggle slot="end" checked disabled></ion-toggle>
        </ion-item>
        @if (selectedCategory === 'essential') {
          <div class="category-description">
            {{ translations[currentLang].essentialDescription }}
          </div>
        }
      </div>
    </div>

    <!-- FUNCTIONAL -->
    <div class="consent-section">
      <div class="category-box" (click)="toggleDetails('functional')">
        <ion-item lines="full" class="toggle-row">
          <ion-label>
            <h3>{{ translations[currentLang].functional }}</h3>
          </ion-label>
          <ion-toggle slot="end" [(ngModel)]="preferences.functional"></ion-toggle>
        </ion-item>
        @if (selectedCategory === 'functional') {
          <div class="category-description">
            {{ translations[currentLang].functionalDescription }}
          </div>
        }
      </div>
    </div>

    <!-- ANALYTICS -->
    <div class="consent-section">
      <div class="category-box" (click)="toggleDetails('analytics')">
        <ion-item lines="full" class="toggle-row">
          <ion-label>
            <h3>{{ translations[currentLang].analytics }}</h3>
          </ion-label>
          <ion-toggle slot="end" [(ngModel)]="preferences.analytics"></ion-toggle>
        </ion-item>
        @if (selectedCategory === 'analytics') {
          <div class="category-description">
            {{ translations[currentLang].analyticsDescription }}
          </div>
        }
      </div>
    </div>

    <!-- PERFORMANCE -->
    <div class="consent-section">
      <div class="category-box" (click)="toggleDetails('performance')">
        <ion-item lines="full" class="toggle-row">
          <ion-label>
            <h3>{{ translations[currentLang].performance }}</h3>
          </ion-label>
          <ion-toggle slot="end" [(ngModel)]="preferences.performance"></ion-toggle>
        </ion-item>
        @if (selectedCategory === 'performance') {
          <div class="category-description">
            {{ translations[currentLang].performanceDescription }}
          </div>
        }
      </div>
    </div>

    <!-- ADVERTISEMENT -->
    <div class="consent-section">
      <div class="category-box" (click)="toggleDetails('advertisement')">
        <ion-item lines="full" class="toggle-row">
          <ion-label>
            <h3>{{ translations[currentLang].advertisement }}</h3>
          </ion-label>
          <ion-toggle slot="end" [(ngModel)]="preferences.advertisement"></ion-toggle>
        </ion-item>
        @if (selectedCategory === 'advertisement') {
          <div class="category-description">
            {{ translations[currentLang].advertisementDescription }}
          </div>
        }
      </div>
    </div>

    <!-- UNCATEGORIZED -->
    <div class="consent-section">
      <div class="category-box" (click)="toggleDetails('uncategorized')">
        <ion-item lines="full" class="toggle-row">
          <ion-label>
            <h3>{{ translations[currentLang].uncategorized }}</h3>
          </ion-label>
          <ion-toggle slot="end" [(ngModel)]="preferences.uncategorized"></ion-toggle>
        </ion-item>
        @if (selectedCategory === 'uncategorized') {
          <div class="category-description">
            {{ translations[currentLang].uncategorizedDescription }}
          </div>
        }
      </div>
    </div>

    <!-- BUTTONS -->
    <div class="button-row-inline">
      <ion-button fill="solid" (click)="rejectAll()" style="--background: black; --color: #fff;">
        {{ translations[currentLang].rejectAll }}
      </ion-button>


      <ion-button fill="solid" (click)="savePreferences()" style="--background: darkgrey  ; --color: #fff;">
        {{ translations[currentLang].save }}
      </ion-button>

      <ion-button fill="solid" (click)="acceptAll()" class="buttonColoring" style="--color: #000;">
        {{ translations[currentLang].acceptAll }}
      </ion-button>

    </div>
  </div>
</ion-content>
